import React from 'react';
import { createUseStyles } from 'react-jss';
import { IPeriodData } from '../model/IPeriodData';
import { MostFrequentStatCard } from './MostFrequentStatCard';
import { CareHoursStatCard } from './CareHoursStatCard';
import { PersonalTimeStatCard } from './PersonalTimeStatCard';
import { FeelingStatCard } from './FeelingStatCard';

const useStyles = createUseStyles(() => ({
    wrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',

        '& ion-card': {
            // force 2 columns
            width: '40%',
            flexGrow: 1
        }
    }
}));

export const JournalOverviewCards: React.FC<{selectedPeriod: IPeriodData, priorPeriod: IPeriodData}> = ({ selectedPeriod, priorPeriod }) => {

    const classes = useStyles();

    return (
        <div className={classes.wrapper}>

            <FeelingStatCard
                selectedPeriod={selectedPeriod}
                priorPeriod={priorPeriod}
            />

            <CareHoursStatCard
                selectedPeriod={selectedPeriod}
                priorPeriod={priorPeriod}
            />

            <PersonalTimeStatCard
                selectedPeriod={selectedPeriod}
                priorPeriod={priorPeriod}
            />

            <MostFrequentStatCard
                data-id="most-freq-care-event-card"
                description="most frequent care event"
                type="CARE_EVENTS"
                checkins={selectedPeriod.care}
            />

            <MostFrequentStatCard
                data-id="most-freq-emotion-card"
                description="most frequent emotion"
                type="EMOTIONS"
                checkins={selectedPeriod.personal}
            />

            <MostFrequentStatCard
                data-id="most-freq-life-event-card"
                description="most frequent life event"
                type="LIFE_EVENTS"
                checkins={selectedPeriod.personal}
            />

        </div>
    );
};
